import { Button, Control, Field, Help, Input, Title, Select, Icon } from 'rbx';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUserTag } from '@fortawesome/free-solid-svg-icons';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import isUUID from 'is-uuid';
import useUser from '../hooks/useUser';

function UserSearch() {
  const {
    user,
    isLoading,
    getUserById,
    getUserByEmail,
    error,
    userVersion,
    setUserVersion,
  } = useUser();
  const [value, setValue] = useState(user ? user.id : '');
  const changeHandler = e => setValue(e.target.value);
  const history = useHistory();
  async function submitHandler(e) {
    e.preventDefault();
    // Check if value is a UUID (user ID) or email
    // and use the corresponding user query function.
    const isUserId = isUUID.anyNonNil(value);
    const getUser = isUserId ? getUserById : getUserByEmail;
    const isBluepill = userVersion === 'bluepill';
    await getUser(value, isBluepill);
    history.push({
      pathname: '/account',
      search: `?email=${isUserId ? value : encodeURIComponent(value)}`,
    });
  }

  return (
    <>
      <Title size={5}>Find a user</Title>
      <form
        onSubmit={submitHandler}
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <Field kind="addons" horizontal expanded style={{ width: '50%' }}>
          <Control expanded>
            <Input
              disabled={isLoading}
              placeholder="Search by user ID or email"
              value={value}
              onChange={changeHandler}
              color={error ? 'danger' : ''}
            />
            {error && <Help color="danger">{error}</Help>}
          </Control>
          <Control>
            <Button type="submit" color="primary" disabled={isLoading}>
              Search
            </Button>
          </Control>
        </Field>
        <Control iconLeft>
          <Select.Container>
            <Select
              value={userVersion}
              onChange={e => setUserVersion(e.target.value)}
              disabled={false}
            >
              <Select.Option value="builder">Builder</Select.Option>
              <Select.Option value="bluepill">Bluepill</Select.Option>
            </Select>
          </Select.Container>
          <Icon size="small" align="left">
            <FontAwesomeIcon icon={faUserTag} />
          </Icon>
        </Control>
      </form>
    </>
  );
}

export default UserSearch;
